// extracted by mini-css-extract-plugin
export default {"content":"ProductMenu_content__HqsrD","heading":"ProductMenu_heading__Q5Ug2","backBtn":"ProductMenu_backBtn__UWtIY","headGroup":"ProductMenu_headGroup__5vu6f"};